import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { X } from "lucide-react";
import { useState } from "react";
import type { Announcement } from "@shared/schema";

export function AnnouncementsBanner() {
  const [dismissedAnnouncements, setDismissedAnnouncements] = useState<number[]>([]);

  const { data: announcements } = useQuery<Announcement[]>({
    queryKey: ["/api/announcements/active"],
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });

  const activeAnnouncements = announcements?.filter(
    (announcement) => !dismissedAnnouncements.includes(announcement.id)
  );

  const dismissAnnouncement = (id: number) => {
    setDismissedAnnouncements((prev) => [...prev, id]);
  };

  if (!activeAnnouncements?.length) {
    return null;
  }

  return (
    <div className="space-y-2">
      {activeAnnouncements.map((announcement) => (
        <div
          key={announcement.id}
          className="relative flex items-center justify-between px-4 py-3 text-sm font-medium shadow-sm"
          style={{
            backgroundColor: announcement.backgroundColor || "#359df3",
            color: announcement.textColor || "#ffffff",
          }}
        >
          <div className="flex-1 text-center">
            <span className="font-semibold">{announcement.title}</span>
            {announcement.message && (
              <span className="ml-2">{announcement.message}</span>
            )}
          </div>
          <button
            onClick={() => dismissAnnouncement(announcement.id)}
            className="ml-4 flex-shrink-0 p-1 hover:opacity-75 transition-opacity"
            aria-label="Dismiss announcement"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}